import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '<',
        canManage: '='
    },
    template: `
    <div class="well color03">
        <div class="heading01 type01">
            <h2>{{ 'skill.Skills' | translate }}</h2>
            <a class="btn add" ng-if="vm.PrivilegeService.canManageUserSkills() && vm.canManage" ng-click="vm.addSkill()">{{ 'user.Add skill' | translate }}</a>
        </div>

        <ul class="grid-list in-5-cols skill-list" ng-if="vm.loading">
            <li class="skill-item skeleton-item" ng-repeat="i in [1,2,3,4,5]">
                <div class="skeleton skeleton-title"></div>
                <div class="skeleton skeleton-bar"></div>
            </li>
        </ul>
        <ul class="grid-list in-5-cols skill-list" ng-if="!vm.loading">
            <li ng-attr-tabindex="{{ vm.PrivilegeService.canManageUserSkills() && vm.canManage ? 0 : undefined }}"
                ng-repeat="userSkill in vm.userSkills track by userSkill.id"
                ng-click="vm.PrivilegeService.canManageUserSkills() && vm.canManage && vm.addSkill(userSkill)"
                ng-class="{ 'skill-item--clickable': vm.PrivilegeService.canManageUserSkills() && vm.canManage }"
                class="skill-item">
                <h3>{{ vm.getSkillName(userSkill.skill.i18ns) }}</h3>
                <skill-user-bar user-skill="userSkill"/>
            </li>
        </ul>
    </div>
    <style>
    /* Skeleton loading styles */
    .skill-list .skeleton-item {
        pointer-events: none;
    }

    .skill-list .skeleton {
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: skeletonLoading 1.5s ease-in-out infinite;
        border-radius: 4px;
    }

    .skill-list .skeleton-title {
        height: 20px;
        width: 70%;
        margin-bottom: 10px;
    }

    .skill-list .skeleton-bar {
        height: 30px;
        width: 100%;
    }

    @keyframes skeletonLoading {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }

    /* Animation for skill items */
    .skill-list .skill-item:not(.skeleton-item) {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
        animation: skillItemFadeIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
    }

    /* Stagger animation for each item */
    .skill-list .skill-item:not(.skeleton-item):nth-child(1) { animation-delay: 0.05s; }
    .skill-list .skill-item:not(.skeleton-item):nth-child(2) { animation-delay: 0.1s; }
    .skill-list .skill-item:not(.skeleton-item):nth-child(3) { animation-delay: 0.15s; }
    .skill-list .skill-item:not(.skeleton-item):nth-child(4) { animation-delay: 0.2s; }
    .skill-list .skill-item:not(.skeleton-item):nth-child(5) { animation-delay: 0.25s; }
    .skill-list .skill-item:not(.skeleton-item):nth-child(6) { animation-delay: 0.3s; }
    .skill-list .skill-item:not(.skeleton-item):nth-child(7) { animation-delay: 0.35s; }
    .skill-list .skill-item:not(.skeleton-item):nth-child(8) { animation-delay: 0.4s; }
    .skill-list .skill-item:not(.skeleton-item):nth-child(9) { animation-delay: 0.45s; }
    .skill-list .skill-item:not(.skeleton-item):nth-child(10) { animation-delay: 0.5s; }
    .skill-list .skill-item:not(.skeleton-item):nth-child(n+11) { animation-delay: 0.55s; }

    @keyframes skillItemFadeIn {
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    /* AngularJS ng-enter animation for newly added items */
    .skill-list .skill-item.ng-enter {
        opacity: 0;
        transform: translateY(20px) scale(0.9);
        animation: none;
    }

    .skill-list .skill-item.ng-enter-active {
        opacity: 1;
        transform: translateY(0) scale(1);
        transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    /* Clickable skill items */
    .skill-list .skill-item--clickable {
        cursor: pointer;
    }

    .skill-list .skill-item:not(.skill-item--clickable) {
        cursor: default;
    }
    </style>
    `
})
export default class {
    constructor (ModalService, ListFactory, UserSkillResource, TokenService, PrivilegeService, DATATABLES, $stateParams,
        $timeout, I18nService, $element, $scope) {
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.UserSkillResource = UserSkillResource;
        this.TokenService = TokenService;
        this.ListFactory = ListFactory;
        this.DATATABLES = DATATABLES;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.I18nService = I18nService;
        this.$element = $element;
        this.$scope = $scope;
        this.destroyed = false;
        this.timeouts = [];
    }

    $onInit () {
        this.scrollToSkillSection();
        this.findSkills(true); // Show skeleton on initial load
    }

    $onDestroy () {
        this.destroyed = true;
        // Cancel all pending timeouts
        this.timeouts.forEach(timeout => {
            this.$timeout.cancel(timeout);
        });
        this.timeouts = [];
    }

    findSkills (showLoading = false) {
        // Only show skeleton on initial load, not on refresh
        if (showLoading) {
            this.loading = true;
        }

        const prevWidths = {};
        // Scope query to component element instead of entire document
        const componentElement = this.$element[0];
        componentElement.querySelectorAll('.bar .fill').forEach(fill => {
            prevWidths[fill.dataset.skillId] = window.getComputedStyle(fill).width;
        });

        this.UserSkillResource.query({
            userId: this.user.id,
            includeAnonymizedUsers: true,
            sort: 'id',
            expand: 'skill,skill.scale.proficiencies,skill.activeI18n,skill.i18ns,skill.explanations.i18ns,skill.explanations.proficiency,requiredProficiency,proficiency'
        })
        .$promise.then((userSkills) => {
            // Prevent memory leak: don't update if component is destroyed
            if (this.destroyed) return;

            this.userSkills = userSkills;
            if (showLoading) {
                this.loading = false;
            }

            // Use $timeout instead of setTimeout so we can cancel it
            const timeout = this.$timeout(() => {
                if (this.destroyed) return;

                const fills = componentElement.querySelectorAll('.bar .fill');
                fills.forEach(fill => {
                    const skillId = fill.dataset.skillId;
                    const prevWidth = prevWidths[skillId];
                    const newWidth = window.getComputedStyle(fill).width;

                    if (prevWidth && prevWidth !== newWidth) {
                        // ensure transition is active
                        fill.style.transition = 'width 1s ease-in-out';
                    }
                });
            }, 100);

            this.timeouts.push(timeout);
        });
    }

    getSkillName (i18ns) {
        const i18n = this.I18nService.getPreferredI18n(i18ns);

        if (!i18n || !i18n.name) {
            return 'no translation';
        }
        return i18n.name;
    }

    addSkill (activeSkill = null) {
        const { user, userSkills } = this;
        return this.ModalService.open({
            template: `
                <modals-competence-user-add-skill on-close="vm.$uibModalInstance.dismiss()" on-update="vm.update()"
                user="vm.user" active-skill="vm.activeSkill" user-skills="vm.userSkills" class="wrapper"></modals-competence-user-add-skill>
                `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.activeSkill = activeSkill;
                this.userSkills = userSkills;
                this.user = user;
                this.update = this.$uibModalInstance.close;
            }
        })
        .then(() => {
            // Prevent memory leak: don't update if component is destroyed
            if (this.destroyed) return;
            this.findSkills();
        });
    }

    scrollToSkillSection () {
        if (this.$stateParams.section === 'skills') {
            const timeout = this.$timeout(() => {
                if (this.destroyed) return;

                const el = document.getElementById('positions-section');
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                }
            }, 1000);

            this.timeouts.push(timeout);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/skills/index.js